/**
 * Strips emojis from text to improve screen reader accessibility.
 *
 * @param text - The text to strip emojis from
 * @returns The text with emojis removed
 */
export const stripEmojis = (text: string): string => {
    return (
        text
            // Remove all Extended_Pictographic characters (covers most emojis)
            .replace(/\p{Extended_Pictographic}/gu, "")
            // Remove Emoji_Modifier characters (skin tone modifiers)
            .replace(/\p{Emoji_Modifier}/gu, "")
            // Emoji_Component was removed because it was removing digits
            // so we are removing the variation selectors, etc with specific regex.
            // Remove variation selectors (FE00-FE0F)
            .replace(/[\uFE00-\uFE0F]/g, "")
            // Remove zero-width joiner (200D)
            .replace(/\u200D/g, "")
            // Remove combining enclosing keycap (20E3)
            .replace(/\u20E3/g, "")
            // Clean up any extra whitespace that might be left
            .replace(/\s+/g, " ")
            .trim()
    );
};
